import React from "react";
import SpecificationRow from "./SpecificationRow";

/**
 * Renders a specification table with headers and rows
 */
const SpecificationTable = ({ 
  activeTab, 
  headerTitle, 
  headerValue,
  rows,
  isPatentTable,
  productData
}) => {
  const { label } = activeTab;
  const cleanedHeaderTitle = headerTitle?.replace(/\W/g, '').toLowerCase();
  const cleanedHeaderValue = headerValue?.replace(/\W/g, '').toLowerCase();

  // Render patent table rows (special format)
  const renderPatentRows = () => {
    const patents = productData.patents || [];
    return patents.map((item, index) => {
      const [label, value] = item.split("|");
      return (
        <SpecificationRow
          key={`patent-${index}`}
          index={index}
          label={label}
          values={[value]}
          unit=""
          activeTabId={activeTab.id}
        />
      );
    });
  };

  // Render standard specification rows
  const renderSpecificationRows = () => {
    return rows.map((row, index) => {
      const displayValues = getDisplayValues(row, productData);
      
      return (
        <SpecificationRow
          key={`spec-${index}`}
          index={index}
          label={row.fieldTitle}
          values={displayValues}
          unit={row.fieldUnits}
          activeTabId={activeTab.id}
        />
      );
    });
  };

  return (
    <table className="product-spec__table">
      <caption className="product-spec__table-caption">{label}</caption>
      {headerTitle && headerValue ? (
        <thead className="product-spec__table--header">
          <tr className="product-spec__table--row">
            <th className="bold-bold" id={cleanedHeaderTitle} scope="col">{headerTitle}</th>
            <th className="bold-semi-bold" id={cleanedHeaderValue} scope="col">{headerValue}</th>
          </tr>
        </thead>
      ) : null}
      <tbody>{isPatentTable ? renderPatentRows() : renderSpecificationRows()}</tbody>
    </table>
  );
};

// Constants
const FIELDNAME_ITEMSPERCASE = "effectiveUnitsPerCase";
const FIELDNAME_EFFECTIVEUNITSPERCASEUOM = "effectiveUnitsPerCaseUom";
const FIELDSTODISPLAYZEROVALUE = [
  "temperatureMinimumDegF",
  "temperatureMinimumDegC",
  "temperatureMaximumDegF",
  "temperatureMaximumDegC",
];

/**
 * Extract and format display values from product data based on field names
 */
const getDisplayValues = (row, productData) => {
  const displayValues = [];
  
  row.fieldName.split(",").forEach((field) => {
    const trimmedFieldName = field.trim();
    let fieldValue = productData[trimmedFieldName];

    // Special case: append UOM for items per case
    if (
      trimmedFieldName === FIELDNAME_ITEMSPERCASE &&
      productData[trimmedFieldName] &&
      productData[FIELDNAME_EFFECTIVEUNITSPERCASEUOM]
    ) {
      fieldValue = `${fieldValue} ${productData[FIELDNAME_EFFECTIVEUNITSPERCASEUOM]}`;
    }

    if (fieldHasValue(trimmedFieldName, fieldValue)) {
      if (Array.isArray(fieldValue)) {
        displayValues.push(...fieldValue);
      } else {
        displayValues.push(fieldValue);
      }
    }
  });

  return displayValues;
};

/**
 * Check if a field has a displayable value
 */
const fieldHasValue = (fieldName, fieldValue) => {
  return !!(
    fieldValue ||
    (FIELDSTODISPLAYZEROVALUE.includes(fieldName) &&
      fieldValue !== undefined &&
      fieldValue !== null)
  );
};

export default SpecificationTable;
